import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.object.create";
import "core-js/modules/es6.object.assign";

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

import staticQueryData from "../../public/static/d/647896407.json";
import React from 'react';
import { StaticQuery } from 'gatsby';
import ListGroup from '../components/ListGroup';

var ExampleNavigation =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(ExampleNavigation, _React$Component);

  function ExampleNavigation() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = ExampleNavigation.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        selectedId = _this$props.selectedId,
        items = _this$props.items;
    return React.createElement("div", {
      className: "nav nav-example"
    }, React.createElement(ListGroup, {
      selectedId: selectedId,
      items: items
    }));
  };

  return ExampleNavigation;
}(React.Component);

var NavigationWrapper = function NavigationWrapper(props) {
  return React.createElement(StaticQuery, {
    query: "647896407",
    render: function render(data) {
      return React.createElement(ExampleNavigation, Object.assign({
        items: data.allNavigationJson.edges
      }, props));
    },
    data: staticQueryData
  });
};

export default NavigationWrapper;